exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".composer-root[data-v-75050726] {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  border: 1px solid #ccc;\n}\n.compose-area[data-v-75050726] {\n  position: relative;\n  height: 100%;\n  padding: 1rem;\n}\n[data-v-75050726] .jtk-endpoint {\n  z-index: 1;\n  cursor: grab;\n}\n", ""]);

